<script setup lang="ts">
import type { VNode } from "vue";

defineSlots<{
  buttons: () => VNode;
  default?: () => VNode;
}>();
</script>

<template>
  <div :class="[$attrs['class'], 'tabs']">
    <div class="tabs__buttons">
      <slot name="buttons" />
    </div>

    <div class="tabs__body">
      <slot />
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/jiffy/settings";
@import "frontend/init/jiffy/mixin";
@import "frontend/init/jiffy/button/mixin.scss";
@import "../../ArtworkQualityConfigPanel.scss";

.tabs {
  display: flex;
  flex-direction: column;

  &__buttons {
    display: flex;
    gap: 2px;
    width: 100%;
  }

  &__body {
    display: flex;
    flex-direction: column;
    width: 100%;
    border: 1px solid $primary-light;
    border-radius: 0px 0px 8px 8px;
    padding: 16px;
    position: relative;
  }
}
</style>
